<template>
  <div>
    <v-tooltip top :disabled="permiteSolicitar">
      <v-menu slot="activator" offset-y :disabled="!permiteSolicitar">
        <template v-slot:activator="{ on }">
          <v-btn :color="permiteSolicitar ? 'primary' : 'grey'" dark v-on="on">
            Solicitar
          </v-btn>
        </template>
        <v-list>
          <v-list-tile @click="abrirModalCriarEsclarecimentoImpugnacao('ESCLARECIMENTO')">
            <v-list-tile-title>Esclarecimento</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="abrirModalCriarEsclarecimentoImpugnacao('IMPUGNACAO')">
            <v-list-tile-title>Impugnação</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <span>Conforme a legislação, não é possível solicitar após a data limite</span>
    </v-tooltip>
    <div class="px-2 pt-2">
      <v-expansion-panel>
        <v-expansion-panel-content>
          <template v-slot:header>
            <strong class="primary--text">Esclarecimentos ({{ esclarecimentos.length }})</strong>
          </template>
          <esclarecimento-impugnacao-tabela tipo="ESCLARECIMENTO" class="pb-2" :esclarecimentos-impugnacoes="esclarecimentos"
                                            @visualizar="abrirVisualizacaoEscIpm"/>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <div class="py-2"></div>
      <v-expansion-panel>
        <v-expansion-panel-content>
          <template v-slot:header >
            <strong class="primary--text">Impugnações ({{ impugnacoes.length }})</strong>
          </template>
          <esclarecimento-impugnacao-tabela tipo="IMPUGNACAO" class="pb-2" :esclarecimentos-impugnacoes="impugnacoes"
                                            @visualizar="abrirVisualizacaoEscIpm"/>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </div>
    <modal-visualizar-esclarecimento-impugnacao
            v-if="exibirModalVisualizarEscIpm" max-width="700"
            :itemVisualizando="esclarecimentoImpugnacaoVisualizando"
            class="modal-visualizar-esc-imp"
            @fecharModal="exibirModalVisualizarEscIpm = false"/>
    <modal-criar-esclarecimento-impugnacao
                                           v-if="exibirModalCriarEscIpm"
                                           :exibir="exibirModalCriarEscIpm"
                                           :tipo="tipoEscpIpmCriando"
                                           :licitacaoId="licitacaoId"
                                           max-width="700" class="modal-criar-esc-imp"
                                           @solicitar="solicitarEsclarecimentoImpugnacao"
                                           @fecharModal="exibirModalCriarEscIpm=false"/>

    <modal-mensagem-confirmar-email v-if="exibirModalConfirmarEmail"
                                    :tipo="tipoConfirmarEmail"
                                    :endereco="enderecoConfirmarEmail"
                                    @fechar="exibirModalConfirmarEmail = false;
                                             tipoConfirmarEmail = null;
                                             enderecoConfirmarEmail = null"/>
  </div>
</template>
<script>
import {actionTypes} from '@/core/constants'
import ModalVisualizarEsclarecimentoImpugnacao from '@/views/components/VisualizarEsclarecimentoImpugnacao'
import EsclarecimentoImpugnacaoTabela from '@/views/pages/commons/licitacao/detalhe/etapas-visualizacao/EsclarecimentoImpugnacaoTabela'
import ModalCriarEsclarecimentoImpugnacao from '@/views/components/CriarEsclarecimentoImpugnacao'
import ModalMensagemConfirmarEmail from '@/views/components/ModalMensagemConfirmarEmail'
import moment from 'moment'
import {mapState} from 'vuex'

export default {
    name: 'CredenciamentoVisualizacaoEsclarecimentoImpugnacao',
    components: {
        ModalMensagemConfirmarEmail,
        ModalCriarEsclarecimentoImpugnacao,
        EsclarecimentoImpugnacaoTabela, ModalVisualizarEsclarecimentoImpugnacao},
    data(){
        return {
            esclarecimentos:[],
            impugnacoes:[],
            exibirModalVisualizarEscIpm: false,
            esclarecimentoImpugnacaoVisualizando: null,
            exibirModalCriarEscIpm: false,
            tipoEscpIpmCriando: null,
            licitacaoId: null,
            exibirModalConfirmarEmail: null,
            tipoConfirmarEmail: null,
            enderecoConfirmarEmail: null
        }
    },
    async created() {
        await this.setLicitacaoId()
    },
    async mounted() {
        await this.buscarTodosEsclarecimentoImpugnacao()
    },
    computed:{
        ...mapState(['licitacao', 'parametros']),
        permiteSolicitar() {
            return moment().tz('America/Sao_Paulo').format() < moment(this.licitacao.dataLimiteEsclarecimentoImpugnacao).tz('America/Sao_Paulo').format()
        },
        validarImpugnacaoPublica(){
            return this.parametros.validarImpugnacaoPublica
        },
    },
    methods:{
        async solicitarEsclarecimentoImpugnacao(payload){
            payload.licitacaoId = this.licitacaoId
            await this.$store.dispatch(actionTypes.SOLICITAR_ESCLARECIMENTO_IMPUGNACAO_CREDENCIAMENTO, payload)
            this.exibirModalCriarEscIpm = false
            this.mostrarNotificacaoSucessoDefault()
            if(this.validarImpugnacaoPublica) {
                this.abrirMensagemConfirmarEmail(payload)
            }
            await this.buscarTodosEsclarecimentoImpugnacao()
        },
        abrirMensagemConfirmarEmail(dadosEnvio){
            this.tipoConfirmarEmail = dadosEnvio.tipo
            this.enderecoConfirmarEmail = dadosEnvio.email
            this.exibirModalConfirmarEmail = true
        },
        async buscarTodosEsclarecimentoImpugnacao(){
            const resultado = await this.$store.dispatch(actionTypes.BUSCAR_ESCLARECIMENTO_IMPUGNACAO_CREDENCIAMENTO, this.licitacaoId)
            this.impugnacoes = resultado.impugnacoes
            this.esclarecimentos = resultado.esclarecimentos
        },
        abrirVisualizacaoEscIpm(escIpmVisualizar){
            this.esclarecimentoImpugnacaoVisualizando = escIpmVisualizar
            this.exibirModalVisualizarEscIpm = true
        },
        abrirModalCriarEsclarecimentoImpugnacao(tipo){
            this.tipoEscpIpmCriando = tipo
            this.exibirModalCriarEscIpm = true
        },
        setLicitacaoId(){
            this.licitacaoId = Number(this.$route.params.id)
        }
    }
}
</script>
<style lang="stylus">
.v-expansion-panel:has(.v-expansion-panel__container.v-expansion-panel__container--active)
  border-radius 5px !important

  .v-expansion-panel__header
    border-top-left-radius: 5px
    border-top-right-radius: 5px

  .v-expansion-panel__container
    border-radius 5px !important

.v-expansion-panel:not(:has(.v-expansion-panel__container.v-expansion-panel__container--active))
  border-radius 5px !important

  .v-expansion-panel__header
    border-radius 5px !important

  .v-expansion-panel__container
    border-radius 5px !important

.v-expansion-panel .v-expansion-panel__header
  background-color: #dcdcdc
  border-top-left-radius: 5px
  border-top-right-radius: 5px
  border 1px solid grey

.v-expansion-panel .v-expansion-panel__header
  background-color: #dcdcdc
  border 1px solid grey

.v-expansion-panel  .v-expansion-panel__body
  border-left 1px solid grey
  border-right 1px solid grey
  border-bottom 1px solid grey
  border-bottom-left-radius 5px
  border-bottom-right-radius 5px

</style>